import { Button, DataSource, Label, Layout, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutUILayoutVersions extends Layout {
    buttonOpenBaseVersion: Button;
    labelBaseVersion: Label;
    sourceCustomUiLayout: DataSource;
    switchBaseVersionActive: Switch;
    tableVersions: Table;
}
